<template>
    <base-draggable-modal
        name="download_contract"
        max-height="80vh"
        width="50vw"
        :fullscreen="$vuetify.display.xsOnly"
        ref="download_contract">
      <v-card rounded="xl">
        <base-modal>
          <template #header>
            <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
              <v-toolbar-title class="text-primary">{{ $store.getters.translate('template') }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template #content>
              <v-card-text>
                <v-autocomplete
                    density="default"
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    v-model="template_id"
                    :items="templates"
                    item-title="text"
                    item-value="value"
                    hide-details
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('template') }}<strong>*</strong></span>
                  </template>
                </v-autocomplete>
              </v-card-text>
          </template>
          <template #footer>
            <v-card-text>
              <v-row>
                <v-col>
                  <base-action-button :width="'100%'" @action="closeModal('download_contract')">
                    <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("cancel") }}
                  </base-action-button>
                </v-col>
                <v-col>
                  <base-action-button :background="true" :width="'100%'" @action="downloadContract">
                    <template #prepend><PhDownloadSimple style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("download") }}
                  </base-action-button>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </base-modal>
      </v-card>
    </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhDownloadSimple, PhX} from "@phosphor-icons/vue";

export default {
  props: ["inspection_id"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhDownloadSimple, PhX,
  },
  data() {
    return {
      templates: [],
      template_id: null
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('download_contract');
      this.templates = await helpFunctions.getAdditionalModelsForDropdowns("template", "id", ["name"]);
    },
    async downloadContract() {
      if(!this.template_id) {
        this.$toast.error(this.$store.getters.translate("please_select_template"));
      }
      else {
        let response = await helpFunctions.getPDFFile(this.$toast, "pdf/download-contract", { inspection_id: this.inspection_id, template_id: this.template_id });
        const blob = new Blob([response], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Contract for " + this.record.project_number + ".pdf";
        link.click();
        URL.revokeObjectURL(link.href);
      }
    },
  }
};
</script>